export const TOKEN_TIME = 'tokenTime'

// token 到期时间 抛弃
export const TOKEN_TIME_VALUE = 2 * 60 * 60 * 1000
